import { arrayOf, string, shape, bool } from "prop-types";

import StyledLink from "../StyledLink/StyledLink.jsx";
import cx from "classnames";

const propTypes = {
  title: string,
  contentUrl: string,
  images: shape({
    mobile1X: string.isRequired,
    desktop1X: string.isRequired,
    mobile2X: string.isRequired,
    desktop2X: string.isRequired,
  }).isRequired,
  imageAlt: string,
  quoteText: string,
  imageIcon: bool,
  secondaryLink: string,
  secondaryLinkText: string,
  body: arrayOf(string),
};

const PersonItem = (props) => {
  const {
    title,
    contentUrl,
    images,
    imageAlt,
    quoteText,
    imageIcon,
    secondaryLink,
    secondaryLinkText,
    body,
  } = props;

  return (
    <div className="person-item">
      {images && (
        <div
          className={cx("person-item__image-wrapper", {
            "person-item__image-wrapper--with-quote": quoteText,
          })}
        >
          <img
            srcSet={`
             ${images.mobile1X} 250w,
             ${images.desktop1X} 350w,
             ${images.mobile2X} 500w,
             ${images.desktop2X} 700w
           `}
            sizes="
              (min-width: 1115px) 335px, 
              (min-width: 746px) calc((100vw - 70px - 80px) / 3), 
              (min-width: 680px) calc((100vw - 70px - 40px) / 2),
              (min-width: 420px) 350px, 
              calc(100vw - 70px)
            "
            src={images.mobile1X}
            alt={imageAlt ? imageAlt : ""}
            loading="lazy"
          />
          {quoteText && (
            <div className="person-item__quote-text">
              <div dangerouslySetInnerHTML={{ __html: quoteText }}></div>
            </div>
          )}
          {imageIcon && <div className="person-item__camera-icon"></div>}
        </div>
      )}
      {title && (
        <div className="person-item__name h5">
          {contentUrl ? (
            <StyledLink className="person-item__name-link" href={contentUrl}>
              {title}
            </StyledLink>
          ) : (
            title
          )}
        </div>
      )}

      <div className="person-item__titles">
        {body.map((text, i) => (
          <div key={i}>{text}&nbsp;</div>
        ))}
        {secondaryLink && (
          <a className="person-item__secondary-link" href={secondaryLink}>
            {secondaryLinkText ? secondaryLinkText : "LinkedIn"}
          </a>
        )}
      </div>
    </div>
  );
};

PersonItem.propTypes = propTypes;
export default PersonItem;

// {graduationYear && (
//   <span className="person-item__graduation-year">
//     {graduationYear}&nbsp;
//   </span>
// )}
// {program && (
//   <span className="person-item__program">{program}&nbsp;</span>
// )}
// {title && <span className="person-item__title">{title}&nbsp;</span>}
// {companyName && (
//   <span className="person-item__company-name">{companyName}</span>
// )}
